import { render, staticRenderFns } from "./domainSelect.vue?vue&type=template&id=5f9bd41f"
import script from "./domainSelect.vue?vue&type=script&lang=js"
export * from "./domainSelect.vue?vue&type=script&lang=js"
import style0 from "./domainSelect.vue?vue&type=style&index=0&id=5f9bd41f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports